"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var RadioTabState_1 = require("./RadioTabState");
var styles = require("./RadioTab.css");
var RadioTabProps_1 = require("./RadioTabProps");
var RadioTabStylesMap_1 = require("./RadioTabStylesMap");
var RadioTab = /** @class */ (function (_super) {
    __extends(RadioTab, _super);
    function RadioTab(props) {
        var _this = _super.call(this, props) || this;
        _this.inputId = _this.guid();
        _this.containerId = _this.guid();
        _this.state = new RadioTabState_1.default();
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        return _this;
    }
    RadioTab.prototype.componentDidMount = function () {
        if (this.props.selected) {
            this.setState({ isVisited: true });
        }
    };
    RadioTab.prototype.handleKeyPress = function (e) {
        if ((this.props.data.disabled === undefined || this.props.data.disabled === false) &&
            (e.key === 'Enter' || e.charCode === 13)) {
            this.props.events.onKeyPress(this.props.data.value);
        }
    };
    RadioTab.prototype.handleOnChange = function (event) {
        this.setState({ isVisited: true });
        this.props.events.onChange(event);
    };
    RadioTab.prototype.isFirstTab = function (props) {
        return (props.data && props.data.isFirstTab && (props.data.isFirstTab === true)) ? styles.firstTab : '';
    };
    RadioTab.prototype.isLastTab = function (props) {
        return (props.data && props.data.isLastTab && (props.data.isLastTab === true)) ? styles.lastTab : '';
    };
    RadioTab.prototype.render = function () {
        var classes = [this.getTabType(this.props.type)];
        var labelClasses = this.props.data.disabled ?
            [styles.radioTabItem, styles.disabled, classes, this.props.className,
                this.isFirstTab(this.props), this.isLastTab(this.props)].join(' ') :
            [styles.radioTabItem, classes, this.props.className,
                this.isFirstTab(this.props), this.isLastTab(this.props)].join(' ');
        return (React.createElement("label", { tabIndex: 0, id: this.containerId, "data-test-id": this.props.testId, className: (this.props.selected) ? [labelClasses, styles.labelActive].join(' ') : labelClasses, htmlFor: this.inputId, onKeyPress: this.handleKeyPress },
            React.createElement("input", __assign({ id: this.inputId, "aria-labelledby": this.containerId, className: styles.radioTabInput, type: "radio", name: this.props.name, checked: this.props.selected, onChange: this.handleOnChange }, this.props.data)),
            React.createElement("div", null,
                this.props.options &&
                    this.props.options.iconFont &&
                    this.props.options.iconName &&
                    this.props.options.iconType &&
                    this.isIconVisible(this.props.options.iconType) && (React.createElement("i", { className: this.getIconClasses() })),
                this.renderText())));
    };
    RadioTab.prototype.getIconClasses = function () {
        return [styles.icon, this.props.options.iconFont,
            this.props.options.iconName, this.getIconType(this.props.options.iconType)].join(' ');
    };
    RadioTab.prototype.isIconVisible = function (type) {
        var isVisible = false;
        if (this.props.selected && type === 'activeComplete') {
            isVisible = true;
        }
        if ((type === 'inactiveComplete' && !this.props.selected && this.state.isVisited)) {
            isVisible = true;
        }
        if ((this.props.selected && type === 'activeInvalid')) {
            isVisible = true;
        }
        if ((type === 'activeInactiveComplete' && (this.props.selected || this.state.isVisited))) {
            isVisible = true;
        }
        return isVisible;
    };
    RadioTab.prototype.getTabType = function (type) {
        return RadioTabStylesMap_1.variationMap.get(type);
    };
    RadioTab.prototype.getIconType = function (type) {
        var result = '';
        switch (type) {
            case 'activeComplete':
                result = this.props.selected ? styles.activeComplete : styles.inactiveComplete;
                break;
            case 'inactiveComplete':
                result = !this.props.selected ? styles.inactiveComplete : styles.activeComplete;
                break;
            case 'activeInvalid':
                result = this.props.selected ? styles.activeInvalid : '';
                break;
            case 'activeInactiveComplete':
                result = this.props.selected ? styles.activeComplete : styles.inactiveComplete;
                break;
        }
        return result;
    };
    RadioTab.prototype.renderText = function () {
        var text = this.props.children ? this.props.children : this.props.data.value;
        return React.createElement("span", { className: styles.radioTabItemText }, text);
    };
    RadioTab.prototype.guid = function () {
        return "" + this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
    };
    RadioTab.prototype.S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    RadioTab.defaultProps = {
        className: '',
        type: RadioTabProps_1.RadioTabsVariations.TAB_A,
    };
    return RadioTab;
}(React.Component));
exports.default = RadioTab;
//# sourceMappingURL=RadioTab.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tabs/components/RadioTab/RadioTab.js
// module id = 1269
// module chunks = 8